import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CampeonatosService } from '../services/campeonatosService';
import { TabelasPesoService } from '../services/tabelasPesoService';

function CriarCampeonato() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [tabelasPeso, setTabelasPeso] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [toast, setToast] = useState(null);

  const showToast = (message, type = 'success') => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 4000);
  };

  const [formData, setFormData] = useState({
    nome: '',
    data_inicio: '',
    data_fim: '',
    local: '',
    cidade: '',
    estado: '',
    tabela_peso_id: '',
    status: 'INSCRIÇÕES ABERTAS'
  });

  const [premiacoes, setPremiacoes] = useState([
    { colocacao: 'Medalhas para os 3 Primeiros', premio: 'Ouro, Prata, Bronze' },
    { colocacao: 'Equipe Campeã', premio: 'Troféu' }
  ]);
  
  const [lotes, setLotes] = useState([
    { nome: 'Lote Único', valor: 140.00 }
  ]);

  const [capaFile, setCapaFile] = useState(null);
  const [capaPreview, setCapaPreview] = useState('');

  useEffect(() => {
    TabelasPesoService.listar()
      .then(data => setTabelasPeso(data))
      .catch(err => console.error("Erro ao carregar tabelas:", err));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setCapaFile(file);
      setCapaPreview(URL.createObjectURL(file));
    }
  };

  const addPremio = () => {
    setPremiacoes([...premiacoes, { colocacao: '', premio: '' }]);
  };

  const updatePremio = (index, field, value) => {
    const newP = [...premiacoes];
    newP[index][field] = value;
    setPremiacoes(newP);
  };

  const addLote = () => {
    setLotes([...lotes, { nome: '', valor: 0 }]);
  };

  const updateLote = (index, field, value) => {
    const newL = [...lotes];
    newL[index][field] = value;
    setLotes(newL);
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      const submitData = new FormData();
      Object.keys(formData).forEach(key => {
        submitData.append(key, formData[key]);
      });
      submitData.append('premiacoes', JSON.stringify(premiacoes));
      submitData.append('lotes_inscricao', JSON.stringify(lotes));
      
      if (capaFile) {
        submitData.append('capa', capaFile);
      }

      await CampeonatosService.criar(submitData);
      showToast('Campeonato criado com sucesso!', 'success');
      setTimeout(() => navigate('/campeonatos'), 1500);
    } catch (err) {
      console.error(err);
      showToast('Erro ao criar campeonato!', 'error');
      setSubmitting(false);
    }
  };

  const renderStep = () => {
    switch(step) {
      case 1:
        return (
          <div className="wizard-step">
            <h2>Passo 1: Dados do Evento</h2>
            <div className="form-group">
              <label>Nome do Circuito/Campeonato *</label>
              <input type="text" name="nome" value={formData.nome} onChange={handleChange} placeholder="Ex: Circuito Carioca de Jiu-Jitsu" />
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Data Início *</label>
                <input type="date" name="data_inicio" value={formData.data_inicio} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Data Fim *</label>
                <input type="date" name="data_fim" value={formData.data_fim} onChange={handleChange} />
              </div>
            </div>
            <div className="form-group">
              <label>Local (Ginásio/Clube) *</label>
              <input type="text" name="local" value={formData.local} onChange={handleChange} placeholder="Ex: Clube 4 Linhas - Bento Ribeiro" />
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Cidade</label>
                <input type="text" name="cidade" value={formData.cidade} onChange={handleChange} placeholder="Ex: Rio de Janeiro" />
              </div>
              <div className="form-group">
                <label>Estado (UF)</label>
                <input type="text" name="estado" value={formData.estado} onChange={handleChange} placeholder="Ex: RJ" maxLength="2" />
              </div>
            </div>
          </div>
        );
      case 2:
        return (
          <div className="wizard-step">
            <h2>Passo 2: Identidade Visual (Capa)</h2>
            <p>Faça o upload do banner de divulgação do evento (Ex: Aquele pôster de 20 de Setembro).</p>
            
            <div className="upload-container">
              {capaPreview ? (
                <div className="capa-preview">
                  <img src={capaPreview} alt="Preview da Capa" />
                  <button type="button" className="btn-outline danger mt-2" onClick={() => { setCapaFile(null); setCapaPreview(''); }}>Remover Imagem</button>
                </div>
              ) : (
                <div className="upload-placeholder">
                  <span>📎 Selecionar Imagem (Máx 5MB)</span>
                  <input type="file" accept="image/*" onChange={handleFileChange} />
                </div>
              )}
            </div>
          </div>
        );
      case 3:
        return (
          <div className="wizard-step">
            <h2>Passo 3: Premiações & Investimento</h2>
            
            <div className="section-block">
              <h3>🏆 Premiações</h3>
              {premiacoes.map((p, index) => (
                <div key={index} className="form-row">
                  <div className="form-group flex-2">
                    <input type="text" value={p.colocacao} onChange={e => updatePremio(index, 'colocacao', e.target.value)} placeholder="Colocação (Ex: Equipe Campeã)" />
                  </div>
                  <div className="form-group flex-2">
                    <input type="text" value={p.premio} onChange={e => updatePremio(index, 'premio', e.target.value)} placeholder="Prêmio (Ex: Troféu / R$ 1000)" />
                  </div>
                </div>
              ))}
              <button type="button" className="btn-outline small" onClick={addPremio}>+ Adicionar Prêmio</button>
            </div>

            <div className="section-block">
              <h3>💲 Lotes de Inscrição</h3>
              {lotes.map((l, index) => (
                <div key={index} className="form-row">
                  <div className="form-group flex-2">
                    <input type="text" value={l.nome} onChange={e => updateLote(index, 'nome', e.target.value)} placeholder="Lote (Ex: Único)" />
                  </div>
                  <div className="form-group flex-1">
                    <input type="number" step="0.01" value={l.valor} onChange={e => updateLote(index, 'valor', parseFloat(e.target.value))} placeholder="Valor (R$)" />
                  </div>
                </div>
              ))}
              <button type="button" className="btn-outline small" onClick={addLote}>+ Adicionar Lote</button>
            </div>
          </div>
        );
      case 4:
        return (
          <div className="wizard-step">
            <h2>Passo 4: Regras & Conclusão</h2>
            
            <div className="form-group">
              <label>Tabela de Pesos a Utilizar *</label>
              <select name="tabela_peso_id" value={formData.tabela_peso_id} onChange={handleChange}>
                <option value="">-- Selecione uma Matriz de Pesos --</option>
                {tabelasPeso.map(t => (
                  <option key={t.id} value={t.id}>{t.nome}</option>
                ))}
              </select>
              <p className="help-text">Esta tabela definirá as categorias GI e NO-GI para a pesagem dos atletas.</p>
            </div>

            <div className="form-group">
              <label>Status Inicial *</label>
              <select name="status" value={formData.status} onChange={handleChange}>
                <option value="RASCUNHO">Rascunho (Apenas visível pra você)</option>
                <option value="INSCRIÇÕES ABERTAS">Inscrições Abertas (Público)</option>
              </select>
            </div>
            
            <div className="summary-alert">
              <strong>🎉 Quase lá!</strong> Revise as informações anteriores se necessário e clique em Publicar Campeonato para salvar e gerar a página oficial do evento!
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="campeonatos-container fade-in">
      {toast && (
        <div className={`toast-notification ${toast.type}`}>
          {toast.message}
        </div>
      )}
      <div className="wizard-header">
        <h1>Criar Novo Campeonato</h1>
        <div className="wizard-steps-indicator">
          <span className={step >= 1 ? 'active' : ''}>1. Dados</span>
          <span className="separator">❯</span>
          <span className={step >= 2 ? 'active' : ''}>2. Capa</span>
          <span className="separator">❯</span>
          <span className={step >= 3 ? 'active' : ''}>3. Prêmios</span>
          <span className="separator">❯</span>
          <span className={step >= 4 ? 'active' : ''}>4. Regras</span>
        </div>
      </div>

      <div className="wizard-body">
        {renderStep()}
      </div>

      <div className="wizard-footer">
        {step > 1 && (
          <button className="btn-outline" onClick={() => setStep(step - 1)}>Voltar</button>
        )}
        <div style={{ flex: 1 }}></div>
        {step < 4 ? (
          <button className="btn-primary" onClick={() => setStep(step + 1)}>Avançar</button>
        ) : (
          <button className="btn-primary success" onClick={handleSubmit} disabled={submitting}>
            {submitting ? 'Salvando...' : 'Publicar Campeonato'}
          </button>
        )}
      </div>
    </div>
  );
}

export default CriarCampeonato;
